import { Icon, Modal } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import stopPropagation from "astrid-helpers/src/stopPropagation";

import useLoadingFunction from "../../hooks/useLoadingFunction";

import PrimaryButton from "../Buttons/PrimaryButton";
import SecondaryButton from "../Buttons/SecondaryButton";
import ErrorMessage from "../Messages/ErrorMessage";

export default function ModalPrompt({
	icon,
	error,
	size = "small",
	disabled,
	header,
	children,
	onClose,
	onSave,
	onError,
	confirmText,
	beforeContent,
	afterContent,
	closeOnConfirm = true,
	showConfirmButton = true,
	...props
}) {
	const { t } = useTranslation();

	const [onConfirm, loading, confirmError] = useLoadingFunction(onSave, {
		onSuccess: closeOnConfirm ? onClose : undefined,
		onError,
	});

	return (
		<Modal open size={size} onClose={onClose} onKeyDown={stopPropagation} onClick={stopPropagation} {...props}>
			{header && (
				<Modal.Header>
					{icon && <Icon name={icon} />} {header}
				</Modal.Header>
			)}
			{beforeContent}

			<Modal.Content>
				{children}

				{(error || confirmError) && <ErrorMessage error={error || confirmError} />}
			</Modal.Content>

			{afterContent}

			<Modal.Actions>
				<SecondaryButton content={t("cancel")} onClick={onClose} />

				{showConfirmButton && (
					<PrimaryButton
						content={confirmText || t("save")}
						disabled={disabled}
						loading={loading}
						onClick={onConfirm}
					/>
				)}
			</Modal.Actions>
		</Modal>
	);
}
